import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@Component({
    selector: 'xui-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressBarModule]
})
export class LoadingComponent {
  readonly progress = input(0);
  readonly showProgress = input(false);
}
